/* eslint import/no-cycle:0 */
import {
	SET_SURVEYS,
	SET_VISIBLE_SURVEYS,
	SET_CONVERTED_READINGS,
	SET_FILTERS
} from '../actions/additionalSurveys';

const defaultState = {
	filtersByTimeuuid: {
		// will look like:
		// 'DEPOL': { filterText, filteredReadings }
	},
	surveys: [],
	datFilesByTimeuuid: {
		// will look like:
		// 'DEPOL': [{gpsreadings: ....}]
	},
	visibleSurveys: [],
	convertedReadingsByTimeuuid: {
		// Will look like:
		// 'DEPOL': {'file.csv': []}
	},
	convertedReadingsKeyToIndexesByTimeuuid: {}
};

const reducer = (state = defaultState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_SURVEYS:
			return {
				...state,
				surveys: payload.surveys,
				datFilesByTimeuuid: payload.datFilesByTimeuuid
			};
		case SET_VISIBLE_SURVEYS:
			return { ...state, visibleSurveys: payload };
		case SET_CONVERTED_READINGS:
			return {
				...state,
				convertedReadingsByTimeuuid: payload.convertedReadingsByTimeuuid,
				convertedReadingsKeyToIndexesByTimeuuid:
					payload.convertedReadingsKeyToIndexesByTimeuuid
			};
		case SET_FILTERS:
			return {
				...state,
				filtersByTimeuuid: payload.filtersByTimeuuid
			};
		default:
			return state;
	}
};

export default reducer;
